"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.doesComponentExtendStyledComponent = doesComponentExtendStyledComponent;
exports.getComponentStats = getComponentStats;
exports.isInstanceOfComponent = isInstanceOfComponent;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../constants");
/* eslint zillow/react/forbid-prop-types: 0 */

var tShirtSize = _propTypes.default.oneOf(Object.values(_constants.T_SHIRT_SIZES));
var inlineMediaQuery = function inlineMediaQuery(propType) {
  return _propTypes.default.oneOfType([propType, _propTypes.default.shape({
    default: propType,
    xs: propType,
    xs_lte: propType,
    xs_eq: propType,
    xs_gte: propType,
    sm: propType,
    sm_lte: propType,
    sm_eq: propType,
    sm_gte: propType,
    md: propType,
    md_lte: propType,
    md_eq: propType,
    md_gte: propType,
    lg: propType,
    lg_lte: propType,
    lg_eq: propType,
    lg_gte: propType,
    xl: propType,
    xl_lte: propType,
    xl_eq: propType,
    xl_gte: propType,
    xxl: propType,
    xxl_lte: propType,
    xxl_eq: propType,
    xxl_gte: propType
  })]);
};

/**
 * Parses classes and instances for useful information.
 */
function getComponentStats(component) {
  var isInstance = !!component.type;
  var type = isInstance ? component.type : component;
  var styledComponentId = type.styledComponentId;
  var isStyledComponent = !!styledComponentId;
  var foldedComponentIds = type.foldedComponentIds;
  var identifier;
  if (typeof type === 'string') {
    // HTML element
    identifier = type;
  } else {
    // React Component || Styled Component
    identifier = type.name || type.displayName;
  }
  return {
    isInstance: isInstance,
    isStyledComponent: isStyledComponent,
    identifier: identifier,
    styledComponentId: styledComponentId,
    foldedComponentIds: foldedComponentIds
  };
}

/**
 * Helper function for comparing component types.
 */
function inTypeHeirarchy(component, type) {
  var _getComponentStats = getComponentStats(component),
    identifier = _getComponentStats.identifier,
    foldedComponentIds = _getComponentStats.foldedComponentIds;
  var expected = getComponentStats(type);
  if (identifier === expected.identifier) {
    return true;
  }
  if (foldedComponentIds && expected.styledComponentId && foldedComponentIds.indexOf(expected.styledComponentId) >= 0) {
    return true;
  }
  return false;
}

/**
 * Tests if the given component class matches, or is an extension of the given
 * component type.
 */
function doesComponentExtendStyledComponent(component, type) {
  var _getComponentStats2 = getComponentStats(component),
    isInstance = _getComponentStats2.isInstance,
    isStyledComponent = _getComponentStats2.isStyledComponent;
  if (isInstance || !isStyledComponent) {
    return false;
  }
  return inTypeHeirarchy(component, type);
}

/**
 * Tests if the given component is an instance of the given component type,
 * including superclasses when it is a styled-component.
 */
function isInstanceOfComponent(component, type) {
  var _getComponentStats3 = getComponentStats(component),
    isInstance = _getComponentStats3.isInstance;
  if (!isInstance) {
    return false;
  }
  return inTypeHeirarchy(component, type);
}
var _default = {
  /**
   * Custom proptype validator that validates the given prop is an instance
   * of the given component.
   *
   * Usage:
   *
   *     label: instanceOfComponent(Label).isRequired,
   *     control: PropTypes.oneOfType([
   *         instanceOfComponent(Checkbox),
   *         instanceOfComponent(Radio),
   *     ]).isRequired,
   */
  instanceOfComponent: function instanceOfComponent(expected) {
    // Using oneOfType allows us to chain this custom prop-type validator
    return _propTypes.default.oneOfType([function _instanceOfComponent(props, propName, componentName) {
      if (!isInstanceOfComponent(props[propName], expected)) {
        var _getComponentStats4 = getComponentStats(props[propName]),
          identifier = _getComponentStats4.identifier;
        return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Component type `" + identifier + "` not allowed.");
      }
      return null;
    }]);
  },
  /**
   * Custom proptype validator that validates the given prop is an extension
   * of the given styled-component class.
   */
  extendsStyledComponent: function extendsStyledComponent(expected) {
    // Using oneOfType allows us to chain this custom prop-type validator
    return _propTypes.default.oneOfType([function _extendsStyledComponent(props, propName, componentName) {
      if (!doesComponentExtendStyledComponent(props[propName], expected)) {
        var _getComponentStats5 = getComponentStats(props[propName]),
          identifier = _getComponentStats5.identifier;
        return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Component type `" + identifier + "` not allowed.");
      }
      return null;
    }]);
  },
  mediaQuery: _propTypes.default.shape({
    xs: _propTypes.default.object,
    xs_lte: _propTypes.default.object,
    xs_eq: _propTypes.default.object,
    xs_gte: _propTypes.default.object,
    sm: _propTypes.default.object,
    sm_lte: _propTypes.default.object,
    sm_eq: _propTypes.default.object,
    sm_gte: _propTypes.default.object,
    md: _propTypes.default.object,
    md_lte: _propTypes.default.object,
    md_eq: _propTypes.default.object,
    md_gte: _propTypes.default.object,
    lg: _propTypes.default.object,
    lg_lte: _propTypes.default.object,
    lg_eq: _propTypes.default.object,
    lg_gte: _propTypes.default.object,
    xl: _propTypes.default.object,
    xl_lte: _propTypes.default.object,
    xl_eq: _propTypes.default.object,
    xl_gte: _propTypes.default.object,
    xxl: _propTypes.default.object,
    xxl_lte: _propTypes.default.object,
    xxl_eq: _propTypes.default.object,
    xxl_gte: _propTypes.default.object
  }),
  tShirtSize: tShirtSize,
  spacing: inlineMediaQuery(_propTypes.default.oneOfType([_propTypes.default.number, tShirtSize])),
  ref: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })]),
  popperPlacement: _propTypes.default.oneOf(['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'left-start', 'left', 'left-end', 'right-start', 'right', 'right-end', 'bottom-start', 'bottom', 'bottom-end']),
  inlineMediaQuery: inlineMediaQuery
};
exports.default = _default;